import React from 'react'
import icon1 from '../images/icon-01.svg'
import icon2 from '../images/icon-2.svg'

export const Banner = () => {
    return (
        <div className="banner">
            <div
                className="icon-1"
            >
                <img src={icon1} alt='' />
            </div>
            <div
                className="icon-2"
            >
                <img src={icon2} alt='' />
            </div>
            <div className="container">
                <div className="content">
                    <h3
                    //     className="wow animate__animated animate__bounceInUp"
                    // data-wow-duration="1.2s"
                    // data-wow-delay="0.1s"
                    >
                        <div
                            className="wow animate__animated animate__fadeInUp"
                            data-wow-duration="1.2s"
                            data-wow-delay="0.1s"
                        >
                            We help <span className='g-green'>Entrepreneurs</span> build{" "}
                            {/* <span className='g-green'> */}
                            <span className='bold-span'>Personal Brands </span>
                            {/* </span> */}
                            {/* <br /> */}
                            that <span className='g-green'>Speak, Sell & Scale</span>
                        </div>
                        {/* <div
                            className="wow animate__animated animate__fadeInUp"
                            data-wow-duration="1.2s"
                            data-wow-delay="0.2s"
                        >
                            That Speak, Sell & Scale
                        </div> */}
                    </h3>
                    <p>
                        Through our data-driven strategies, we generate consistent 100% organic Leads & engagement —with 0 ad spend. <span className='mobile-none'>For founders, coaches, and consultants, we create a growth engine that attracts the right audience, establishes authority, and scales your business 10x.</span>
                    </p>
                    <a href='#contact' className='btn btn-primary'>
                        BOOK A CALL
                        <span>&nbsp;<i className="fa-solid fa-arrow-right"></i></span>
                    </a>
                </div>
            </div>
        </div>
    )
}
